import { useEffect, useState } from "react";
import { createUseStyles } from "react-jss";

import widgets from "styles/widgets";
import { UserDto } from "dtos/user.dto";
import displayStyles from "styles/display-styles";
import { ActionEffectDto } from "dtos/shard/action-effect.dto";

import ActionEffectView from "../views/action-effect-view";
import ActionEffectEditor from "../editors/action-effect-editor";
import { statsPanel, toggleStatsPanel } from "utils";

const styles = createUseStyles({});

export default function ActionEffectDisplay(props: {
    user?: UserDto, // Optional dto of the user.
    className?: string, // Optional css class name to use.
    actionEffect?: Partial<ActionEffectDto>, // The actionEffect dto to display, if undefined a blank actionEffect will be displayed instead.
    onSave?: (actionEffect: ActionEffectDto) => void, // A function to call when created or updated.
    onClose?: () => void, // A function to call when the close button is clicked, if not set the close button is hidden.
}): JSX.Element
{
    // States:
    const [stats, setStats] = useState(statsPanel());
    const [actionEffectPreview, setActionEffectPreview] = useState(props.actionEffect);

    // Effects:
    useEffect(() => {
        setActionEffectPreview(props.actionEffect);
    }, [props.actionEffect]);

    // Styles:
    const widgetClasses = widgets();
    const displayClasses = displayStyles();
    const classes = styles();

    // Components:
    let statsComp: JSX.Element | undefined;
    if (stats) {
        // ActionEffect Stats (Editor for Admins):
        if (props.user?.super) {
            statsComp = (
                <div className={`${displayClasses.stats}`}>
                    <div className={`${displayClasses.editor}`}>
                        <h3>Editor:</h3>
                        <ActionEffectEditor
                            user={props.user}
                            actionEffect={props.actionEffect}
                            preview={actionEffectPreview}
                            onPreviewUpdate={setActionEffectPreview}
                            onSave={props.onSave}
                            onClose={props.onClose}
                        />
                    </div>
                </div>
            );
        } else {
            statsComp = (
                <div className={`${displayClasses.stats}`}>
                    <div className={`${widgetClasses.column}`}>
                        <h3>Stats:</h3>
                        <ul>
                            <li>Name: {props.actionEffect?.name}</li>
                        </ul>
                    </div>
                </div>
            );
        }
    }

    // Return Component:
    return (
        <div className={`${displayClasses.container} ${props.className ?? ""}`}>
            <div className={`${displayClasses.controls}`}>
                <div className={`${displayClasses.button} ${statsPanel() ? displayClasses.buttonActive : ""}`} onClick={() => setStats(toggleStatsPanel())}>
                    <div className={`${displayClasses.icon} ${displayClasses.iconStats}`}></div>
                </div>
                {props.onClose && <div className={`${displayClasses.button}`} onClick={() => props.onClose!()}>
                    <div className={`${displayClasses.icon} ${displayClasses.iconClose}`}></div>
                </div>}
            </div>
            <ActionEffectView actionEffect={actionEffectPreview} />
            {statsComp}
        </div>
    );
}
